// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"style_marginBottom__gT7dz","wrapper":"style_wrapper__UXTuW"};